import angular from "angular"
import "angular-translate"
import "angular-dynamic-locale"

export default angular.module("r2TranslateModule", [
    "pascalprecht.translate",
    "tmh.dynamicLocale",
    "ui.bootstrap"
])